import '../scss/main.scss'

// Espone la base URL al JS (definita dal PHP nel body data-attribute fallback)
window.APP_BASE = window.APP_BASE || ''

const page = document.body.dataset.page

if (page === 'dashboard') {
  Promise.all([
    import('./dashboard.js'),
    import('./commesse-modal.js'),
  ]).then(([{ initDashboard }, { initCommesseModal }]) => {
    initCommesseModal()
    initDashboard()
  })
}

if (page === 'staff') {
  import('./staff.js').then(({ initStaff }) => initStaff())
}

if (page === 'clienti') {
  import('./clienti.js').then(({ initClienti }) => initClienti())
}

if (page === 'admin-users') {
  import('./admin-users.js').then(({ initAdminUsers }) => initAdminUsers())
}

if (page === 'commessa-detail') {
  import('./commessa-detail.js').then(({ initCommessaDetail }) => initCommessaDetail())
}

if (page === 'login') {
  // Toggle visibilità password
  document.querySelector('.btn-toggle-pw')?.addEventListener('click', function () {
    const input = document.getElementById('password')
    input.type  = input.type === 'password' ? 'text' : 'password'
  })
}
